import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Droplets, Flame } from 'lucide-react';
export function Chapter3() {
  return <section id="capitulo-3" className="min-h-screen py-24 px-6 lg:px-16 bg-cream relative" data-id="element-83">
      <div className="max-w-4xl mx-auto" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-85">
          <h2 className="text-gold font-medium tracking-widest uppercase text-sm mb-4" data-id="element-86">
            Capítulo 3
          </h2>
          <h3 className="font-serif text-4xl lg:text-5xl text-darkBrown font-bold mb-10 leading-tight" data-id="element-87">
            La Farmacia Natural
          </h3>
          <p className="text-xl text-darkBrown/80 mb-12 text-balance" data-id="element-88">
            La naturaleza nos ha provisto de compuestos anti-inflamatorios más
            potentes que muchos medicamentos, sin los efectos secundarios. Estos
            son tus tres grandes aliados.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-89">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gold/10" data-id="element-90">
            <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center mb-4 text-deepGold" data-id="element-91">
              <Sparkles className="w-6 h-6" data-id="element-92" />
            </div>
            <h4 className="font-serif text-xl font-bold text-darkBrown mb-3" data-id="element-93">
              La Cúrcuma
            </h4>
            <p className="text-darkBrown/70 text-base" data-id="element-94">
              Contiene curcumina, el anti-inflamatorio natural más estudiado.
              Bloquea las enzimas que causan dolor e hinchazón a nivel celular.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gold/10" data-id="element-95">
            <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center mb-4 text-deepGold" data-id="element-96">
              <Flame className="w-6 h-6" data-id="element-97" />
            </div>
            <h4 className="font-serif text-xl font-bold text-darkBrown mb-3" data-id="element-98">
              El Jengibre
            </h4>
            <p className="text-darkBrown/70 text-base" data-id="element-99">
              Estimula la digestión lenta y reduce los gases. Sus gingeroles
              actúan directamente sobre el dolor articular y la rigidez
              matutina.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gold/10" data-id="element-100">
            <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center mb-4 text-deepGold" data-id="element-101">
              <Droplets className="w-6 h-6" data-id="element-102" />
            </div>
            <h4 className="font-serif text-xl font-bold text-darkBrown mb-3" data-id="element-103">
              Canela de Ceilán
            </h4>
            <p className="text-darkBrown/70 text-base" data-id="element-104">
              Estabiliza los picos de azúcar en sangre, evitando que el cuerpo
              almacene grasa abdominal. Asegúrate de que sea variedad "Ceilán",
              no Cassia.
            </p>
          </motion.div>
        </div>

        {/* Recipe Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-darkBrown text-cream rounded-3xl overflow-hidden shadow-xl" data-id="element-105">
          <div className="p-8 lg:p-12" data-id="element-106">
            <div className="inline-block px-3 py-1 bg-gold/20 text-gold rounded-full text-sm font-medium mb-6 uppercase tracking-wider" data-id="element-107">
              Receta Estrella
            </div>
            <h4 className="font-serif text-3xl lg:text-4xl font-bold mb-4 text-white" data-id="element-108">
              El Elixir Dorado
            </h4>
            <p className="text-cream/80 text-lg mb-8 max-w-2xl" data-id="element-109">
              Tu ritual nocturno. Esta bebida caliente calma el sistema
              nervioso, reduce la inflamación mientras duermes y prepara tu
              cuerpo para quemar grasa.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-110">
              <div data-id="element-111">
                <h5 className="font-serif text-xl text-gold mb-4 border-b border-gold/20 pb-2" data-id="element-112">
                  Ingredientes
                </h5>
                <ul className="space-y-3 text-cream/90" data-id="element-113">
                  <li className="flex items-center gap-3" data-id="element-114">
                    <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-115"></div>1
                    taza de leche de almendras o coco
                  </li>
                  <li className="flex items-center gap-3" data-id="element-116">
                    <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-117"></div>1
                    cucharadita de cúrcuma en polvo
                  </li>
                  <li className="flex items-center gap-3" data-id="element-118">
                    <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-119"></div>
                    1/2 cucharadita de jengibre en polvo
                  </li>
                  <li className="flex items-center gap-3" data-id="element-120">
                    <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-121"></div>
                    1/4 cucharadita de canela de Ceilán
                  </li>
                  <li className="flex items-center gap-3" data-id="element-122">
                    <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-123"></div>
                    Una pizca de pimienta negra{' '}
                    <span className="text-sm text-cream/50" data-id="element-124">
                      (¡Crucial para absorber la cúrcuma!)
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-125">
                    <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-126"></div>
                    1/2 cucharadita de aceite de coco o ghee
                  </li>
                </ul>
              </div>

              <div data-id="element-127">
                <h5 className="font-serif text-xl text-gold mb-4 border-b border-gold/20 pb-2" data-id="element-128">
                  Instrucciones
                </h5>
                <ol className="space-y-4 text-cream/90 list-decimal list-inside" data-id="element-129">
                  <li className="pl-2" data-id="element-130">
                    Calienta la leche en una olla pequeña a fuego medio. No
                    dejes que hierva.
                  </li>
                  <li className="pl-2" data-id="element-131">
                    Añade todas las especias y el aceite de coco.
                  </li>
                  <li className="pl-2" data-id="element-132">
                    Usa un batidor de mano para mezclar bien hasta que esté
                    espumoso y dorado.
                  </li>
                  <li className="pl-2" data-id="element-133">
                    Sirve en tu taza favorita. Tómalo 30 minutos antes de
                    dormir.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}